/* global location */
import React from 'react';
import PropTypes from 'prop-types';
import { injectStripe } from 'react-stripe-elements';
import { ApolloProvider } from 'react-apollo';
import gql from 'graphql-tag';

import {
  unhandledDataSelector,
  unhandledSelectedSelector,
  availablePaymentsForOrder,
} from '@arreeba/ristoranti-frontend-lib';

import VoucherHelpers from '@arreeba/ristoranti-frontend-lib/lib/helpers/voucher';

import Cart from '@arreeba/ristoranti-lib/lib/cart';

import {
  PAYMENT_METHOD_CC,
  PAYMENT_UNHANDLED,
} from '@arreeba/ristoranti-frontend-lib/lib/constants';

import { userCreditCardsSelector } from '@arreeba/ristoranti-frontend-lib/lib/selectors/user';

import { COMMON_LOCALIZED } from '../../lib/localized';

import { connect } from '../../util';
import Spinner from '../../components/spinner';
import ButtonsContainer from '../../components/buttonsContainer';
import BackButton from '../../components/back-button';
import Button from '../../components/button';

import PaymentHeader from '../../components/payment/payment-header';
import Unhandled from '../../components/payment/unhandled';
import SavedCreditCard from '../../components/payment/saved-credit-card';
import AddStripeCreditCard from '../../components/payment/add-stripe-credit-card';

const STRIPE_PAYMENT_INTENT_QUERY = gql`
  query stripePaymentIntent(
      $appId: ID!,
      $restaurant: ID!,
      $cartTotal: Int!,
    ){
    app(id: $appId) {
      id
      stripePaymentIntent(
        cartTotal: $cartTotal,
        restaurant: $restaurant,
      )
    }
  }`;


class OrderPayment extends React.Component {
  constructor(props) {
    super(props);
    this.selectUnhandled = this.selectUnhandled.bind(this);
    this.selectSavedCard = this.selectSavedCard.bind(this);
    this.selectNewCard = this.selectNewCard.bind(this);
    this.createOrder = this.createOrder.bind(this);
    this.storeOrder = this.storeOrder.bind(this);
    this.resetState = this.resetState.bind(this);

    this.state = {
      selectedCardId: null,
      showNewCardForm: false,
    };
  }

  getTotal() {
    const { order, orderType, voucher, url } = this.props;

    return order.selectedVoucher ?
      VoucherHelpers.cartTotalWithVoucher(
        order.cart,
        order.extraCosts[url.orderType],
        order.selectedVoucher,
        voucher.instances || [],
      ) :
      Cart.total(order.cart, order.extraCosts[url.orderType]);
  }

  resetState() {
    this.setState({
      selectedCardId: null,
      showNewCardForm: false,
    });
  }

  selectUnhandled(value) {
    const amount = !value ? this.props.unhandledData[0].value : value;
    this.setState({
      selectedCardId: null,
      showNewCardForm: false,
    });
    this.props.actions.order.setPaymentUnhandled(parseInt(amount, 10));
  }

  selectSavedCard(cardId) {
    this.props.actions.order.setPaymentCreditCard();
    this.setState({
      selectedCardId: cardId,
      showNewCardForm: false,
    });
  }

  selectNewCard() {
    this.props.actions.order.setPaymentCreditCard();
    this.setState({
      selectedCardId: null,
      showNewCardForm: true,
    });
  }

  createOrder() {
    const { stripe, order } = this.props;
    const noCard = !this.state.selectedCardId;
    const noCash = !order.unhandledExpectedAmount;
    const noNewCard = !this.state.showNewCardForm;

    const orderActions = this.props.actions.order;

    if (noCard && noCash && noNewCard) {
      alert('Seleziona un metodo di pagamento per proseguire');
      return;
    }

    // unhandled
    if (order.unhandledExpectedAmount) {
      this.storeOrder({ cashAmount: order.unhandledExpectedAmount });
      return;
    }

    if (this.props.availablePayments[PAYMENT_METHOD_CC] && this.props.app.config.payments.nexi) {
      // nexi
      // TODO this.storeOrder({ cardId: this.state.selectedCardId });
    } else {
      this.setState({ stripeLoading: true });
      this.props.apolloClient.query({
        query: STRIPE_PAYMENT_INTENT_QUERY,
        variables: {
          appId: this.props.app.id,
          cartTotal: this.getTotal(),
          restaurant: this.props.url.restaurantId,
        },
        fetchPolicy: 'no-cache',
      }).then(({ data }) => {
        const paymentIntentId = data && data.app && data.app[0] && data.app[0].stripePaymentIntent;
        // console.log('intent from api ' + paymentIntent);
        const { selectedCardId: paymentMethodId } = this.state;

        stripe.handleCardPayment(
          paymentIntentId,
          {
            ...(paymentMethodId ? { payment_method: paymentMethodId } : { save_payment_method: true }),
          },
        )
          .then((response) => {
            this.setState({ stripeLoading: false });
            if (response.error) {
              const message = 'Si è verificato un problema con il pagamento.';
              orderActions.storeOrderFailure([{ message }]);
            } else if (response.paymentIntent && response.paymentIntent.status === 'requires_capture') {
              this.storeOrder({ stripePaymentIntentId: response.paymentIntent.id });
            }
          }).catch((error) => {
            this.setState({ stripeLoading: false });
            const message = 'Si è verificato un problema con il pagamento.';
            orderActions.storeOrderFailure([{ message }]);
          });
      }).catch((error) => {
        this.setState({ stripeLoading: false });
        const message = 'Si è verificato un problema con il pagamento.';
        orderActions.storeOrderFailure([{ message }]);
      });
    }

    // const selectedCardId = this.state.selectedCardId;
    // const data = selectedCardId && selectedCardId !== TMP_NEW_CARD ?
    //   { cardId: this.state.selectedCardId } :
    //   { card: this.state.newCardData };

    // this.storeOrder(data);
  }

  storeOrder(data) {
    const { services, app, order, user, voucher, url } = this.props;
    const orderActions = this.props.actions.order;
    const orderData = {
      app,
      order: {
        ...order,
        orderType: url.orderType,
        orderDate: url.orderDate,
        targetRestaurant: url.restaurantId,
        sourceType: 'web',
        source: location.hostname,
      },
      user: user.currentUser,
      userVouchers: voucher.instances,
    };
    services.order.createOrder(
      app.id,
      {
        ...orderData,
        ...data,
      }, orderActions)
      .catch((errors) => {
        console.log(errors);
        const message = 'Si è verificato un problema con il pagamento.';
        orderActions.storeOrderFailure([{ message }]);
      });
  }

  render() {
    const { stripeLoading } = this.state;

    return (
      <ApolloProvider client={this.props.apolloClient}>
        <main>
          <PaymentHeader />
          {this.props.user.isFetching || this.props.order.isFetching ?
            <div className="paymentContainer container--loading">
              <Spinner size="large" text="Pagamento in corso..." />
            </div> :
            <div className="paymentContainer">
              {this.props.availablePayments[PAYMENT_METHOD_CC] &&
                this.props.userCreditCards.map(card => (
                  <SavedCreditCard
                    {...card}
                    key={card.id}
                    active={this.state.selectedCardId === card.id}
                    onSelect={() => this.selectSavedCard(card.id)}
                  />
                ))}

              {this.props.availablePayments[PAYMENT_METHOD_CC] && !(this.props.app.config.payments && this.props.app.config.payments.nexi) && // stripe
                <AddStripeCreditCard
                  active={this.state.showNewCardForm}
                  onSelect={this.selectNewCard}
                />
              }

              {this.props.availablePayments[PAYMENT_UNHANDLED] &&
                <Unhandled
                  values={this.props.unhandledData}
                  active={this.props.order.unhandledExpectedAmount !== null}
                  onSelect={this.selectUnhandled}
                />
              }
            </div>
          }
          <ButtonsContainer>
            <BackButton />
            <Button
              type="next"
              text="CONTINUA"
              disabled={stripeLoading}
              onClick={this.createOrder}
            />
          </ButtonsContainer>
        </main>
      </ApolloProvider>
    );
  }
}

OrderPayment.propTypes = {
  availablePayments: PropTypes.shape({
    [PAYMENT_UNHANDLED]: PropTypes.bool,
    [PAYMENT_UNHANDLED]: PropTypes.bool,
  }),
};

const mapStateToProps = (state, props) => ({
  order: state.order,
  user: state.user,
  voucher: state.voucher,
  userCreditCards: userCreditCardsSelector(state, props),
  unhandledData: unhandledDataSelector(COMMON_LOCALIZED.UNHANDLED_LABELS)(state, props),
  unhandledSelected: unhandledSelectedSelector(COMMON_LOCALIZED.UNHANDLED_LABELS)(state, props),
  availablePayments: availablePaymentsForOrder(state, props),
});
export default connect(injectStripe(OrderPayment), { mapStateToProps });



// WEBPACK FOOTER //
// ./src/containers/order/order-payment.js